import api from '@common/api';
import { getArtistID } from '../store';

const EVENT_NAME = 'music_content_event';

export function reportLog(msg: string) {
  api.post('reportLog/report', { eventName: EVENT_NAME, msg }).catch(() => {});
}

export function reportPageView(contentId: string, options?: { withArtistId?: boolean }) {
  let msg = `${contentId}|code=0`;
  if (options?.withArtistId) {
    const artistId = getArtistID();
    msg += `&artist_id=${artistId}`;
  }
  reportLog(msg);
}
